module.exports = __webpack_public_path__ + "img/header-trustpilot.82205240.svg";